module.exports = __webpack_public_path__ + "static/media/icon_browser.841a9041.svg";